/**
 * Odznak s počtem — jeden pro celou mobilní navigaci.
 *
 * Dřív si ho každá vrstva kreslila sama a totéž číslo vypadalo na dvou
 * místech jinak: v liště 14 px s písmem 8,5 a rámečkem barvou pásu, v mřížce
 * modulů 20 px s písmem 11 a prstencem v `--surface-base`. Ten prstenec navíc
 * nesedí — dlaždice leží na skle nad brandovou září, ne na té barvě, takže
 * z něj byl vidět kroužek.
 *
 * Prstenec proto bere barvu podle motivu, ne podle jedné plochy: na skle
 * i na ploše odděluje číslo od toho, co je pod ním.
 *
 * Nulu nekreslí — co nečeká, nemá svítit.
 *
 * @param {number} props.pocet
 * @param {boolean} [props.isDark]
 * @param {Object} [props.style] - umístění (`position: absolute` + souřadnice)
 * @param {string} [props.popis] - přečte čtečka; bez něj je odznak dekorace
 *   a počet říká `aria-label` tlačítka, na kterém sedí
 */
export default function Odznak({ pocet = 0, isDark = true, style, popis }) {
    if (!pocet) return null;

    return (
        <span
            aria-hidden={popis ? undefined : 'true'}
            aria-label={popis}
            style={{
                minWidth: 16,
                height: 16,
                padding: '0 4px',
                borderRadius: 999,
                background: '#EF4444',
                color: '#fff',
                border: `1.5px solid ${isDark ? 'rgba(22,22,30,0.85)' : 'rgba(255,255,255,0.92)'}`,
                fontSize: 9.5,
                fontWeight: 700,
                lineHeight: '13px',
                textAlign: 'center',
                fontVariantNumeric: 'tabular-nums',
                ...style,
            }}
        >
            {pocet > 99 ? '99+' : pocet}
        </span>
    );
}
